export default __webpack_public_path__ + "static/pic01-d0897899a59618b64e0441935a790691.jpg";